import "./ProductsLoadingAnimation.scss";
import { useEffect } from "react";

export const FaceAnalysisAnimation = ({ onDone }) => {
  useEffect(() => {
    // auto-fade out after 2.1s
    const timer = setTimeout(onDone, 2100);
    return () => clearTimeout(timer);
  }, [onDone]);

  return (
    <div className="fade-in-out duration-2000">
      <svg
        width="139"
        height="126"
        viewBox="0 0 139 126"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M69.8237 93.2C75.1753 94.3844 74.7293 92.531 77.4051 92.977C78.6821 93.1898 78.7864 94.0211 80.0809 94.0211C81.4188 94.0211 81.2754 93.4002 82.7567 92.977C84.3176 92.531 84.9866 94.3844 90.5611 93.2M75.8464 80.8655C75.8464 80.8655 78.0762 83.0953 80.0831 83.0953C82.0899 83.0953 84.5427 80.8655 84.5427 80.8655M77.1863 100.04C77.1863 100.04 78.6728 101.378 80.0107 101.378C81.3486 101.378 82.9838 100.04 82.9838 100.04M67.1649 68.007C67.1649 68.007 65.5102 68.6189 63.3742 68.8989C58.7994 69.4985 56.8888 66.9188 52.0021 66.0001M91.6748 68.0469C91.6748 68.0469 93.3295 68.6589 95.4655 68.9388C100.04 69.5384 101.951 66.9587 106.838 66.04M90.3382 55.7843C94.3519 54.6694 95.4668 54.0066 99.2575 54.0004C104.056 53.9926 106.662 54.3458 111.076 56.2302M70.002 54.9988C65.9883 53.8839 64.8734 53.2212 61.0827 53.215C56.2838 53.2071 53.678 53.5604 49.2646 55.4448M36.6052 67.7099C36.6052 67.7099 33.2633 54.1269 34.1524 45.4116C35.449 32.7016 38.2498 25.6106 46.4164 16.4238C54.5831 7.23706 64.1736 1.50676 78.3024 1.03801C89.5326 0.66542 97.8072 2.98809 106.621 9.95731C107.337 10.5236 108.042 11.0998 108.734 11.6866M123.791 68.8248C123.791 68.8248 126.985 52.4619 125.352 39.3911C124.527 32.7868 122.017 27.0557 118.417 22M78.3044 19.3213C85.8858 13.3007 87.0008 11.2939 89.8995 2.37456M80.088 117.434C90.7906 116.759 103.889 106.699 109.076 97.1428C113.312 89.3384 116.434 73.0607 115.541 60.1277C114.629 46.9054 111.75 34.7071 98.5943 30.0245C90.5669 24.2269 91.4588 21.5511 78.5258 19.9902C65.5928 18.4293 60.4642 35.599 57.5654 41.6195C54.6667 47.6401 43.9635 47.7995 43.9635 61.911C43.9635 83.5403 47.087 89.1154 51.0996 97.1428C55.1122 105.17 69.3854 118.109 80.088 117.434Z"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          className="animate-path"
          style={{ animationDelay: "0s" }}
        />
        <path
          d="M43.5 110L44.9855 114.015L49 115.5L44.9855 116.985L43.5 121L42.0145 116.985L38 115.5L42.0145 114.015L43.5 110Z"
          stroke="black"
          strokeWidth="3"
          strokeLinecap="round"
          className="animate-path-bob"
          style={{ animationDelay: "0.15s" }}
        />
        <path
          d="M126.5 78L128.526 83.4743L134 85.5L128.526 87.5257L126.5 93L124.474 87.5257L119 85.5L124.474 83.4743L126.5 78Z"
          stroke="black"
          strokeWidth="3"
          strokeLinecap="round"
          className="animate-path-bob"
          style={{ animationDelay: "0.3s" }}
        />
        <path
          d="M17 53L20.2411 61.7589L29 65L20.2411 68.2411L17 77L13.7589 68.2411L5 65L13.7589 61.7589L17 53Z"
          stroke="black"
          strokeWidth="3"
          strokeLinecap="round"
          className="animate-path-bob"
          style={{ animationDelay: "0.25s" }}
        />
        <path
          d="M120 8L109.219 23L102 18.4893"
          stroke="black"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="animate-path"
          style={{ animationDelay: "0.9s" }}
        />
      </svg>
    </div>
  );
};
